module.exports = __webpack_public_path__ + "static/fonts/Oswald-Regular.727a7582.ttf";